import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { AppSettings } from '../../app.settings';
import { UiService } from '../../services/ui.service';
import { ErrorBindingService } from '../../services/error-binding.service';
import { UserCommonService } from '../../services/user-common.service';

@Component({
  selector: 'app-bulk-imports',
  templateUrl: './bulk-imports.component.html',
  styleUrl: './bulk-imports.component.scss',
  standalone: false
})
export class BulkImportsComponent implements OnInit {

  @Input() screenCode;
  @Output() onBulkImport = new EventEmitter();
  labelBulkImport;
  displayImportBulkImportPopup: boolean = false;
  uploadedFileName;
  labelCancel;

  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService,
    private userCommonService: UserCommonService
  ){}

  ngOnInit(){
    this.labelBulkImport = this.commonBindingDataService.getLabel('label_bulk_import');
    this.labelCancel = this.commonBindingDataService.getLabel('label_cancel');
    console.log(this.screenCode);
  }

  showBulkImportPopup(label) {
    if (label == 'Bulk Import') {
      this.uploadedFileName = '';
      this.displayImportBulkImportPopup = true;
    } else {
      this.displayImportBulkImportPopup = false;
      this.checkBulkImportStatus();
    }
  }

  checkBulkImportStatus() {
    let screenCode = this.screenCode;

    this.commonBindingDataService.checkBulkIportStatus(screenCode).subscribe(result => {
      if (result.fileJobsInprogress) {
        this.labelBulkImport = this.commonBindingDataService.getLabel('label_processing');
      } else {
        this.labelBulkImport = this.commonBindingDataService.getLabel('label_bulk_import');
      }
      setTimeout(() => {
        this.displayImportBulkImportPopup = false;
      }, 1000);

    }, (error) => {
      this.errorBindingService.setMessage({ severity: 'error', summary: 'Error', detail: error.general[0].message });
    });
  }

  onUploadProfile(event) {
    this.uploadedFileName = event.originalFileName;
    const data = {
      "screenCode": this.screenCode,
      "fileName": event.fileId
    }
    this.commonBindingDataService.importBulkFile(data).subscribe((result: any) => {
      this.errorBindingService.setMessage({ severity: 'success', summary: 'Success', detail: result.general[0].message });
      // this.labelBulkImport = this.commonBindingDataService.getLabel('label_processing');
      setTimeout(() => {
        this.displayImportBulkImportPopup = false;
        this.onBulkImport.emit(result.fileName);
      }, 1000);
    }, (error) => {
      this.errorBindingService.setMessage({ severity: 'error', summary: 'Error', detail: error.general[0].message });
      // setTimeout(() => {
      //   this.refreshGrid();
      // }, 1000);
    });
  }

  Cancel() {
    this.displayImportBulkImportPopup = false;
  }

  onDownloadFile() {
    let fileFound = false;
    this.userCommonService.userMetaData?.fileImportTemplatesList?.forEach(element => {
      if (this.screenCode == element.screenCode) {
        this.commonBindingDataService.getDocumentDownload(element.fileId);
        fileFound = true;
      }
    });
    if (!fileFound) {
      this.errorBindingService.setMessage({ severity: 'error', summary: 'Error', detail: this.commonBindingDataService.getLabel('label_download_invalid_file') });
    }
  }

  onDownloadGuidFile() {
    let guideFound = false;
    this.userCommonService.userMetaData?.fileImportTemplatesList?.forEach(element => {
      if (this.screenCode == element.screenCode) {
        this.commonBindingDataService.getDocumentDownload(element.templateGuideFileId);
        guideFound = true;
      }
    });
    if (!guideFound) {
      this.errorBindingService.setMessage({ severity: 'error', summary: 'Error', detail: this.commonBindingDataService.getLabel('label_download_invalid_file') });
    }
  }

}
